import { EditPenIcon, InfoIcon } from '@sharedCR/coreDesignSystem/icons';

export const getLoanDenialWrapperConfig = ({ isLoading, isManageAllowed, onEdit }) => {
  return {
    name: 'Denial Reasons',
    icon: InfoIcon,
    methods: {
      edit: {
        name: 'Edit',
        icon: EditPenIcon,
        onClick: isManageAllowed ? onEdit : undefined,
        disabled: isLoading,
      },
    },
  };
};
